// Cart Complementary Products
// Fetches and renders complementary product recommendations in the cart drawer.
// Defined as a static asset so it is always in memory regardless of cart state at page load,
// allowing it to be called the first time an item is added to an empty cart.

window.initCartComplementaryProducts = function() {
  const wrapper = document.querySelector('.complementary-products-cart-wrapper');
  if (!wrapper) return;

  const container = wrapper.querySelector('.complementary-products-cart__container');
  const loading = wrapper.querySelector('.complementary-products-cart__loading');
  const layout = wrapper.dataset.layout || 'vertical';

  container.innerHTML = '';
  wrapper.style.display = 'none';

  // Resolve the recommendations route — set as a global by cart-drawer.liquid,
  // with a safe fallback to the standard Shopify path.
  const recsBase = window.cartComplementaryRecsUrl || '/recommendations/products';

  fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItems = cart.items;
      if (!cartItems || cartItems.length === 0) {
        wrapper.style.display = 'none';
        return;
      }

      const cartProductIds = cartItems.map(item => item.product_id);

      const allRecommendations = new Map();
      const fetchPromises = [];
      let stylesAdded = false;

      cartProductIds.forEach(productId => {
        const url = recsBase + '?section_id=complementary-products&product_id=' + productId + '&limit=10&intent=complementary';
        fetchPromises.push(
          fetch(url)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const recommendationsSection = doc.querySelector('product-recommendations');
              if (recommendationsSection) {
                const inlineSection = recommendationsSection.querySelector('.complementary-products-inline');
                if (inlineSection) {
                  if (!stylesAdded) {
                    doc.querySelectorAll('style').forEach(styleTag => {
                      if (styleTag.textContent.includes('complementary-products-inline') && !document.getElementById('complementary-products-cart-styles')) {
                        const newStyle = document.createElement('style');
                        newStyle.id = 'complementary-products-cart-styles';
                        newStyle.textContent = styleTag.textContent;
                        document.head.appendChild(newStyle);
                        stylesAdded = true;
                      }
                    });
                  }
                  inlineSection.querySelectorAll('.complementary-products-inline__item').forEach(item => {
                    const productId = parseInt(item.dataset.productId);
                    if (!cartProductIds.includes(productId) && !allRecommendations.has(productId)) {
                      allRecommendations.set(productId, item.cloneNode(true));
                    }
                  });
                }
              }
            })
            .catch(err => console.error('Error fetching recommendations:', err))
        );
      });

      loading.style.display = 'block';

      Promise.all(fetchPromises).then(() => {
        loading.style.display = 'none';

        const recommendationsArray = Array.from(allRecommendations.values());

        // Shuffle (Fisher-Yates)
        for (let i = recommendationsArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [recommendationsArray[i], recommendationsArray[j]] = [recommendationsArray[j], recommendationsArray[i]];
        }

        const limited = recommendationsArray.slice(0, 5);

        if (limited.length === 0) {
          wrapper.style.display = 'none';
          return;
        }

        wrapper.style.display = 'block';

        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'complementary-products-inline';

        const title = document.createElement('h6');
        title.className = 'complementary-products-inline__title';
        title.textContent = 'FREQUENTLY BOUGHT TOGETHER:';
        wrapperDiv.appendChild(title);

        const list = document.createElement('ul');
        list.className = 'complementary-products-inline__list';
        if (layout === 'horizontal') {
          list.classList.add('complementary-products-inline__list--horizontal');
        } else if (layout === 'grid') {
          list.classList.add('complementary-products-inline__list--grid');
        }

        limited.forEach(item => list.appendChild(item));
        wrapperDiv.appendChild(list);
        container.appendChild(wrapperDiv);
      });
    })
    .catch(err => {
      console.error('[Complementary Products Cart] Error fetching cart:', err);
      wrapper.style.display = 'none';
    });
};

// On initial page load, run if the wrapper already exists in the DOM
// (i.e. cart had items when the page was rendered). If the wrapper isn't
// present yet, complementary-products.js will call this after it's injected.
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.complementary-products-cart-wrapper')) {
    window.initCartComplementaryProducts();
  }
});
